export default {
  list: [
    {
      value: 'TOMAN',
      title: 'تومان'
    },
    {
      value: 'RIAL',
      title: 'ریال'
    }
  ],
  values: {
    GROUND_LEVEL: 'TOMAN',
    BASEMENT: 'RIAL',
  }
};
